export default __webpack_public_path__ + "static/media/Manual-5.b2b63c2a.png";